import colorMap from '../../../helpers/colorMap';

const lines = (record) => Object.entries(record).reduce(
    (accumulator, [key, value]) => value
        ? accumulator.concat(
            `[${key}]: `,
            value,
            '\n'
        )
        : accumulator,
    []
).join('');

/**
 * Write log to console (colorised)
 * Send data over HTTP as POST
 * @param  {Object} options
 * @param  {String} options.level
 * @param  {String} options.message
 * @param  {Number} options.time     // here to get ignored
 * @param  {Number} options.severity // here to get ignored
 * @return {undefined}
 */
const logToConsole = () => {
    const context = {};
    async function log({ level, time, severity, message, ...rest }) {
        return console.log( // eslint-disable-line no-console
            `%c ${level}:`,
            `color: ${colorMap[level] || 'inherit'}; font-weight: bold`,
            message,
            '\n',
            lines(rest),
            `\ncontext: ${lines(context)}`
        );
    }

    /**
     * Enrichment allows you to add additional data to all logs
     * @param {() => import('@fiverr-private/relay-sdk').Context} enricher
     * @returns {self} Use an anonymous/named function and return self
     */
    log.setEnricher = function setEnricher(enricher) {
        Object.assign(
            context, enricher()
        );
        return this;
    };
    return log;
};

export default logToConsole;
